var exports = {
  "kL": "EmojiTooltipContent.module__container___YzNPan",
  "Zg": "EmojiTooltipContent.module__emoji___YzNPan",
  "FS": "EmojiTooltipContent.module__textContainer___YzNPan",
  "Lq": "EmojiTooltipContent.module__loading___YzNPan",
  "W$": "EmojiTooltipContent.module__subtext___YzNPan",
  "vW": "EmojiTooltipContent.module__inner___YzNPan",
};

module.exports = exports;
